<div class="container numero-de-dias-letivos">
  <button
    mat-raised-button
    (click)="navegarParaRotaAnterior()"
    class="floating-button float-left"
    *ngIf="exibirBotaoAnterior"
  >
    Anterior
  </button>
  <button
    mat-raised-button
    (click)="navegarParaRotaProximo()"
    class="floating-button float-right"
    *ngIf="exibirBotaoProximo"
  >
    Próximo
  </button>

  <div class="icon-container">
    <app-etapas-de-edicao
      [iconeAndarilhoPreenchido]="iconeAndarilhoPreenchido"
      [iconeAndarilhoBloqueado]="iconeAndarilhoPreenchido"
      [iconeAndarilhoSubtituloBold]="iconeAndarilhoPreenchido"
      [iconeQualidadePreenchido]="iconeQualidadePreenchido"
      [iconeQualidadeBloqueado]="iconeQualidadePreenchido"
      [iconeQualidadeSubtituloBold]="iconeQualidadePreenchido"
      [iconeMoedasPreenchido]="iconeMoedasPreenchido"
      [iconeMoedasBloqueado]="iconeMoedasPreenchido"
      [iconesMoedasSubtituloBold]="iconeMoedasPreenchido"
      [iconeFinanceiroPreenchido]="iconeFinanceiroPreenchido"
      [iconeFinanceiroBloqueado]="iconeFinanceiroPreenchido"
      [iconeFinanceiroSubtituloBold]="iconeFinanceiroPreenchido"
      [novoResultado]="caminhoNovoResultado"
      [caminhoAtual]="caminhoAtual"
      (botaoClicado)="preencheIconeEtapaAtual($event)"
    ></app-etapas-de-edicao>
  </div>

  <div class="circular-card-wrapper">
    <div class="circular-card">
      <span
        >Você está projetando o orçamento educacional para a rede municipal de
        VITÓRIA / 2021</span
      >
    </div>
  </div>

  <section *ngIf="!exibirResultado" class="content-container">
    <div class="content-1">
      <app-lateral-navegacao
        [titulo]="tituloMenuLateral"
        [caminho_imagem]="caminhoImagem"
        [ativos]="opcoesMenuLateralAtivas"
        [inativos]="opcoesMenuLateralInativas"
        [cor_fundo_cabecalho]="corFundoCabecalho"
      >
      </app-lateral-navegacao>
    </div>

    <div class="content-2">
      <router-outlet></router-outlet>
    </div>
  </section>

  <section *ngIf="exibirResultado">
    <router-outlet></router-outlet>
  </section>
</div>
